if (!String.prototype.padStart) {
  String.prototype.padStart = function(n, s){ s = s || ' '; var o = String(this);
    while (o.length < n) { o = s + o; } return o.slice(-Math.max(n, String(this).length)); };
}
/* compatibility shim — older engines lack NodeList.forEach */
if (typeof NodeList !== 'undefined' && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
if (typeof HTMLCollection !== 'undefined' && !HTMLCollection.prototype.forEach) {
  HTMLCollection.prototype.forEach = Array.prototype.forEach;
}
// ── PRODUCT DATA ────────────────────────────────────────────────────────────
const PRODUCTS = [];

// ── CURSOR ─────────────────────────────────────────────────────────────────
const rhCur = document.getElementById('cur');

if (rhCur) {
  const cursorAllowed = window.matchMedia(
    '(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)'
  );

  const hideCursor = () => {
    document.body.classList.remove('rh-cursor-active');
  };

  document.addEventListener('pointermove', (event) => {
    const nativeControl = event.target.closest(
      'input, textarea, select, [contenteditable]'
    );

    if (!cursorAllowed.matches || event.pointerType !== 'mouse' || nativeControl) {
      hideCursor();
      return;
    }

    rhCur.style.transform =
      `translate3d(${event.clientX}px, ${event.clientY}px, 0) translate(-50%, -50%)`;

    document.body.classList.add('rh-cursor-active');
  }, { passive: true });

  document.documentElement.addEventListener('pointerleave', hideCursor);
  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse') hideCursor();
  }, { passive: true });

  window.addEventListener('blur', hideCursor);
  document.addEventListener('visibilitychange', hideCursor);
  cursorAllowed.addEventListener('change', hideCursor);
}
function bindHover(){
  document.querySelectorAll('.hoverable,a,button,input,select,textarea').forEach(el=>{
    el.addEventListener('mouseenter',()=>document.body.classList.add('hov'));
    el.addEventListener('mouseleave',()=>document.body.classList.remove('hov'));
  });
}
bindHover();
document.addEventListener('mousedown',()=>document.body.classList.add('clk'));
document.addEventListener('mouseup',()=>document.body.classList.remove('clk'));

// ── COUNTER ────────────────────────────────────────────────────────────────
function countUp(el,target,dur=2200){
  const s=Date.now();
  (function u(){
    const t=Math.min((Date.now()-s)/dur,1);
    const e=t<.5?2*t*t:-1+(4-2*t)*t;
    el.textContent=String(Math.floor(e*target)).padStart(6,'0');
    if(t<1)requestAnimationFrame(u);
  })();
}

// ── HERO ───────────────────────────────────────────────────────────────────
const heroEl=document.getElementById('hero'),hlEl=document.getElementById('hl'),hsEl=document.getElementById('hs'),hhEl=document.getElementById('hh');
const navEl=document.getElementById('nav');
let heroGone=false;

// The opening sequence exists on the home page only, and only while the theme
// setting is on. Everywhere else — every collection and product page — none of
// these elements are in the document, so the whole block is skipped. Without
// this guard the script threw here and stopped, taking the rest of the page's
// behaviour with it, and left the body locked at overflow:hidden so those
// pages could not be scrolled at all.
function exitHero(){
  if(heroGone)return;heroGone=true;
  if(heroEl)heroEl.classList.add('out');
  if(navEl)navEl.classList.add('on');
  document.body.style.overflowY='auto';
  if(window.__syncHeader)requestAnimationFrame(window.__syncHeader);
}

if(heroEl){
  // Cinematic hero sequence — unhurried, ~7.5s before auto-transition
  if(hlEl) setTimeout(()=>hlEl.classList.add('on'),600);
  // Intro counter is off unless the theme setting supplies a real figure.
  // Bryce: "Only keep it if we can make the number real."
  if(hsEl){
    setTimeout(()=>{
      hsEl.classList.add('on');
      const n=parseInt((hsEl.dataset.count||'').replace(/[^0-9]/g,''),10);
      const el=document.getElementById('cnt');
      if(el&&n>0) countUp(el,n,3200);
    },1800);
  }
  if(hhEl) setTimeout(()=>hhEl.classList.add('on'),4200);
  const ht=setTimeout(exitHero,7500);
  ['wheel','touchmove'].forEach(e=>window.addEventListener(e,()=>{clearTimeout(ht);exitHero();},{once:true,passive:true}));
  heroEl.addEventListener('click',()=>{clearTimeout(ht);exitHero();});
  document.body.style.overflowY='hidden';
}else{
  // No intro on this page: the navigation is shown straight away and the page
  // scrolls normally.
  if(navEl)navEl.classList.add('on');
  document.body.style.overflowY='auto';
}

// ── PAGE ROUTER ─────────────────────────────────────────────────────────────
let currentPage='home';
window.currentProduct=PRODUCTS[2];

function initCategoryIndex(){
  document.querySelectorAll('.cat-tile').forEach((el,i) => {
    if(el.dataset.staggered) return;
    el.dataset.staggered = '1';
    el.style.cssText += 'opacity:0;transform:translateY(16px);transition:opacity .9s var(--ease),transform .9s var(--ease);';
    setTimeout(() => { el.style.opacity='1'; el.style.transform='none'; }, 80 + i*70);
  });
}

// ── HOME INIT ──────────────────────────────────────────────────────────────
// Removed. This was the single-page router's entry point and called
// initChamber(), which no longer exists; the boot at the end of this file now
// initialises every template.

function staggerIn(sel, step, axis){
  document.querySelectorAll(sel).forEach((el,i)=>{
    if(el.dataset.staggered) return;
    el.dataset.staggered='1';
    const from = axis==='x' ? 'translateX(-12px)' : 'translateY(18px)';
    el.style.cssText += `opacity:0;transform:${from};transition:opacity .9s var(--ease),transform .9s var(--ease),background .4s;`;
    const o=new IntersectionObserver(entries=>{
      entries.forEach(e=>{ if(e.isIntersecting){
        setTimeout(()=>{el.style.opacity='1';el.style.transform='none';}, (i%9)*step);
        o.unobserve(el);
      }});
    },{threshold:.06});
    o.observe(el);
  });
}

// ── COLLECTION INIT ────────────────────────────────────────────────────────
const COLLECTIONS = [
  ["sports-cards", "Sports Cards", "01"],
  ["comics", "Comics", "02"],
  ["pokemon", "Pokémon", "03"],
  ["magic-the-gathering", "Magic: The Gathering", "04"]
];
let collActive='all', collSort='new';

// ── REVEALS ───────────────────────────────────────────────────────────────
function initReveals(){
  const obs=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');obs.unobserve(e.target);}}) ,{threshold:.07});
  document.querySelectorAll('.reveal:not(.in)').forEach(el=>obs.observe(el));
}

// ── ACCOUNT TABS ──────────────────────────────────────────────────────────

// ── FORMS ────────────────────────────────────────────────────────────────
/* Not currently wired to a form. Kept honest so it cannot claim a send. */
function submitSell(e){
  if(e && e.preventDefault) e.preventDefault();
  rhSendOrDraft({
    formId:    'sell-form',
    successId: 'sell-success',
    stateId:   'sell-state',
    subject:   'Selling a collection',
    name:  (document.getElementById('sell-name')  || {}).value || '',
    email: (document.getElementById('sell-email') || {}).value || '',
    message: (document.getElementById('sell-msg') || {}).value || ''
  });
}

/* ── SHARED DELIVERY ───────────────────────────────────────────────────
   Sends only when an endpoint is configured and the server accepts it.
   Otherwise it drafts an email and says plainly that nothing has been sent. */
function rhFormState(stateId, afterId, msg, tone){
  var box = document.getElementById(stateId);
  if(!box){
    box = document.createElement('div');
    box.id = stateId;
    box.className = 'form-state';
    var a = document.getElementById(afterId);
    if(!a) return;
    a.parentNode.insertBefore(box, a.nextSibling);
  }
  box.style.color = tone === 'ok' ? 'var(--red)' : 'rgba(250,248,244,.80)';
  box.innerHTML = msg;
}

function rhSendOrDraft(o){
  var form = document.getElementById(o.formId);
  if(!o.email){
    rhFormState(o.stateId, o.formId, 'AN EMAIL ADDRESS IS REQUIRED SO WE CAN REPLY.', 'warn');
    return;
  }
  if(RH_INQUIRY_ENDPOINT){
    fetch(RH_INQUIRY_ENDPOINT, {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({name:o.name, email:o.email, subject:o.subject, message:o.message})
    }).then(function(r){
      if(!r.ok) throw new Error('HTTP ' + r.status);
      if(form) form.style.display = 'none';
      var s = document.getElementById(o.successId);
      if(s) s.style.display = 'block';
    }).catch(function(err){
      rhFormState(o.stateId, o.formId,
        'NOTHING HAS BEEN SENT — THE SERVER REFUSED THE REQUEST (' + err.message + ').<br>'
        + 'PLEASE EMAIL <span style="color:#fff">' + RH_INQUIRY_EMAIL + '</span> DIRECTLY.', 'warn');
    });
    return;
  }
  var body = encodeURIComponent('Object / subject: ' + o.subject + '\n\nFrom: ' + o.name
             + ' (' + o.email + ')\n\n' + o.message);
  var href = 'mailto:' + RH_INQUIRY_EMAIL
           + '?subject=' + encodeURIComponent('RAREHOUSE — ' + o.subject) + '&body=' + body;
  rhFormState(o.stateId, o.formId,
    '<span style="color:#fff">NOTHING HAS BEEN SENT YET. SEND THE MESSAGE FROM YOUR EMAIL APPLICATION.</span><br>'
    + '<a href="' + href + '" style="color:var(--red)">OPEN EMAIL DRAFT</a><br>'
    + 'IF YOUR EMAIL APPLICATION DOES NOT OPEN, WRITE TO<br>'
    + '<span style="color:#fff">' + RH_INQUIRY_EMAIL + '</span><br>'
    + 'SUBJECT: <span style="color:#fff">' + o.subject + '</span>', 'warn');
  var open = document.getElementById(o.stateId).querySelector('a');
  if(open){ open.setAttribute('target','_blank'); open.setAttribute('rel','noopener'); }
}

/* ── INQUIRY DELIVERY ──────────────────────────────────────────────────
   Set RH_INQUIRY_ENDPOINT to a real destination (Shopify contact URL,
   Formspree/Basin endpoint, or any handler accepting a POST).
   Set RH_INQUIRY_EMAIL as the fallback address.
   Until an endpoint is set the form does NOT claim to send: it opens a
   prefilled email instead, so an inquiry is never silently lost. */
var RH_INQUIRY_ENDPOINT = '';
var RH_INQUIRY_EMAIL = 'hello@rarehouse.co';   // address already published in the approved design


function submitContact(e){
  if(e && e.preventDefault) e.preventDefault();
  rhSendOrDraft({
    formId:'contact-form', successId:'contact-success', stateId:'contact-state',
    subject: (document.getElementById('contact-subject')||{}).value || 'General inquiry',
    name:    (document.getElementById('contact-name')   ||{}).value || '',
    email:   (document.getElementById('contact-email')  ||{}).value || '',
    message: (document.getElementById('contact-msg')    ||{}).value || ''
  });
}

// ── COLLECTION FILTER (home) ──────────────────────────────────────────────

// ── INIT ──────────────────────────────────────────────────────────────────
// All pages hidden initially
// Hero shows first; Shopify serves the real page beneath it

// ── QC: TOUCH DEVICE DETECTION ─────────────────────────────────────────────
const IS_TOUCH = window.matchMedia('(hover:none),(pointer:coarse)').matches;
const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if(IS_TOUCH || REDUCED_MOTION){
  const c=document.getElementById('cur');
  if(c)c.style.display='none';
  document.body.style.cursor='auto';
}

// ── QC: KEYBOARD NAVIGATION ────────────────────────────────────────────────
document.addEventListener('keydown',e=>{
  if(e.key==='Tab')document.body.classList.add('kb-nav');
});
document.addEventListener('mousedown',()=>document.body.classList.remove('kb-nav'));

// ── QC: PASSIVE SCROLL LISTENERS ALREADY SET ───────────────────────────────
// ── QC: RESIZE HANDLER (recalculate sticky offsets) ────────────────────────
let rt;
window.addEventListener('resize',()=>{
  clearTimeout(rt);
  rt=setTimeout(()=>{
    document.documentElement.style.setProperty('--vh',window.innerHeight*0.01+'px');
  },150);
},{passive:true});
document.documentElement.style.setProperty('--vh',window.innerHeight*0.01+'px');

// ── QC: ESCAPE CLOSES EVERYTHING ───────────────────────────────────────────
document.addEventListener('keydown',e=>{
  if(e.key!=='Escape') return;
  // Search and cart do not exist in this build. Calling them threw a
  // ReferenceError, so closeMenu() below never ran and Escape did nothing.
  if(typeof closeSearch === 'function') closeSearch();
  if(typeof closeCart   === 'function') closeCart();
  if(typeof closeMenu   === 'function') closeMenu();
});

// ── QC: PREVENT BODY SCROLL LOCK LEAKS ─────────────────────────────────────
window.addEventListener('pageshow',()=>{
  // #srch was removed from this build, so reading its classList threw on every
  // page show. Only overlays that actually exist are consulted.
  var open = ['mov','srch','cart'].some(function(id){
    var el = document.getElementById(id);
    return el && el.classList.contains('on');
  });
  if(!open) document.body.style.overflow='';
});


// ── HEADER MARK: oversized on arrival, scales into nav on scroll ───────────
(function(){
  const nav   = document.getElementById('nav');
  const pages = document.getElementById('pages');
  if(!nav || !pages) return;
  const THRESHOLD = 40;
  let atTop = null, ticking = false;

  function sync(){
    const shouldBeTop = window.scrollY < THRESHOLD;
    if(shouldBeTop !== atTop){
      atTop = shouldBeTop;
      nav.classList.toggle('at-top', atTop);
      pages.classList.toggle('at-top', atTop);
    }
    ticking = false;
  }
  window.addEventListener('scroll',()=>{
    if(!ticking){ requestAnimationFrame(sync); ticking = true; }
  },{passive:true});

  // Set initial state once the hero clears
  window.__syncHeader = sync;
  sync();
})();

// ── LOADING: reveal document once fonts have settled ──────────────────────
(function(){
  function ready(){ document.body.classList.add('ready'); }
  if(document.fonts && document.fonts.ready){
    document.fonts.ready.then(()=>setTimeout(ready,60));
    setTimeout(ready,1800);   // hard fallback — never leave the page blank
  }else{
    window.addEventListener('load',ready);
    setTimeout(ready,1200);
  }
})();


// ── IMAGE HELPERS ─────────────────────────────────────────────────────────
function imgSrc(p, role, small){
  return 'assets/products/' + p.id + '-' + role + (small?'-sm':'') + '.jpg';
}




// ══ DIGITAL SHOWROOM ══════════════════════════════════════════════════════
const CATEGORIES = [
  { slug: "sports-cards", name: "Sports Cards", num: "01" },
  { slug: "comics", name: "Comics", num: "02" },
  { slug: "pokemon", name: "Pokémon", num: "03" },
  { slug: "magic-the-gathering", name: "Magic: The Gathering", num: "04" }
];
// ── INQUIRY — the primary action across the whole site ────────────────────
function inquire(subject, code, url){
  var q = '?subject=' + encodeURIComponent(subject || 'General inquiry');
  if(code) q += '&code=' + encodeURIComponent(code);
  if(url)  q += '&url='  + encodeURIComponent(url);
  window.location.href = (window.RH_CONTACT_URL || '/pages/contact') + q;
}

/* Prefill the Shopify contact form from the URL on arrival. */
function rhPrefillContact(){
  var p = new URLSearchParams(window.location.search);
  var subject = p.get('subject'); if(!subject) return;
  var sel = document.getElementById('contact-subject');
  if(sel){
    var found = false;
    for(var i=0;i<sel.options.length;i++){
      if(sel.options[i].value === subject || sel.options[i].text === subject){ sel.selectedIndex = i; found = true; break; }
    }
    if(!found){
      var o = document.createElement('option');
      o.value = subject; o.text = subject; o.selected = true; sel.appendChild(o);
    }
  }
  var c = document.getElementById('contact-code');  if(c) c.value = p.get('code') || '';
  var u = document.getElementById('contact-url');   if(u) u.value = p.get('url') || '';
  var n = document.getElementById('contact-name');  if(n) n.focus({preventScroll:true});
}
document.addEventListener('DOMContentLoaded', rhPrefillContact);

// ── JUMP TO A CATEGORY MOMENT ON THE HOMEPAGE ────────────────────────────

// ── CATEGORY REVEALS ──────────────────────────────────────────────────────
function initCategories(){
  document.querySelectorAll('.cat').forEach(el => {
    if(el.dataset.bound) return;
    el.dataset.bound = '1';
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if(e.isIntersecting && e.intersectionRatio > 0.18){
          el.classList.add('in');
          io.unobserve(el);
        }
      });
    }, { threshold:[0, .18, .35], rootMargin:'0px 0px -6% 0px' });
    io.observe(el);
    // Safety: if it is already on screen at load, reveal immediately
    const r = el.getBoundingClientRect();
    if(r.top < window.innerHeight * 0.85 && r.bottom > 0) el.classList.add('in');
  });
  // Absolute fallback — nothing stays hidden
  setTimeout(() => document.querySelectorAll('.cat').forEach(el => el.classList.add('in')), 9000);
  if(window.__bindReverse) window.__bindReverse();
}


// ══ MENU ══════════════════════════════════════════════════════════════════
let menuOpen = false;
function openMenu(){
  const mov = document.getElementById('mov');
  const btn = document.getElementById('mbtn');
  if(!mov) return;
  menuOpen = true;
  mov.classList.add('on');
  if(btn){ btn.classList.add('mo'); btn.setAttribute('aria-expanded','true'); }
  document.body.style.overflow = 'hidden';
}
function closeMenu(){
  const mov = document.getElementById('mov');
  const btn = document.getElementById('mbtn');
  if(!mov) return;
  menuOpen = false;
  mov.classList.remove('on');
  if(btn){ btn.classList.remove('mo'); btn.setAttribute('aria-expanded','false'); }
  document.body.style.overflow = '';
}
function toggleMenu(){ menuOpen ? closeMenu() : openMenu(); }

(function bindMenu(){
  const btn = document.getElementById('mbtn');
  if(btn && !btn.dataset.bound){
    btn.dataset.bound = '1';
    btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); toggleMenu(); });
    btn.addEventListener('keydown', e => {
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); toggleMenu(); }
    });
  }
  // Click the overlay background to close
  const mov = document.getElementById('mov');
  if(mov && !mov.dataset.bound){
    mov.dataset.bound = '1';
    mov.addEventListener('click', e => { if(e.target === mov) closeMenu(); });
  }
  document.addEventListener('keydown', e => { if(e.key === 'Escape' && menuOpen) closeMenu(); });
})();


// The Chamber was replaced by the FEATURED ITEMS section, which is rendered
// from real products in Liquid and needs no script of its own.

// ══ STATEMENT — WE BUY LARGE COLLECTIONS ══════════════════════════════════
function initStatement(){
  const wrap = document.querySelector('.stmt-link');
  if(!wrap || wrap.dataset.bound) return;
  wrap.dataset.bound = '1';
  const lines = [...wrap.querySelectorAll('.stmt-line')];

  const show = () => {
    lines.forEach(l => l.classList.add('in'));
    wrap.classList.add('shown');
  };

  if('IntersectionObserver' in window){
    const io = new IntersectionObserver(es => {
      es.forEach(e => { if(e.isIntersecting){ show(); io.disconnect(); } });
    }, { threshold:.2 });
    io.observe(wrap);
  }else{ show(); }

  // Never leave it ghosted
  setTimeout(show, 6000);
  const r = wrap.getBoundingClientRect();
  if(r.top < window.innerHeight * 0.85) show();
}


// ══ FRONT / REVERSE — touch devices tap to toggle ═════════════════════════
(function initReverse(){
  const isTouch = window.matchMedia('(hover:none),(pointer:coarse)').matches;

  function bind(){
    document.querySelectorAll('.cat-visual.has-reverse,.cat-tile.has-reverse').forEach(el => {
      if(el.dataset.revBound) return;
      el.dataset.revBound = '1';

      // Ensure both faces are decoded before any toggle — no flash
      el.querySelectorAll('.face').forEach(img => {
        if(img.complete) return;
        img.addEventListener('error', () => {
          el.classList.remove('has-reverse');
          const back = el.querySelector('.face.back');
          if(back) back.remove();
        }, { once:true });
      });

      // A product tile is a link to the object; a category block and the
      // product page visual are not. On a touch device the tile must still
      // open on tap, so there the flip is driven by the VIEW REVERSE cue
      // alone and a tap anywhere else follows the link.
      const isLink = el.tagName === 'A' || el.closest('a') !== null;

      // The category blocks use .reverse-cue, which is decoration and must not
      // intercept the pointer; a tile uses .tile-reverse-cue, which is a
      // control. Both are matched here.
      const CUE = '.reverse-cue,.tile-reverse-cue';

      const setCue = () => {
        const cue = el.querySelector(CUE);
        if(cue) cue.textContent = el.classList.contains('flipped') ? 'VIEW FRONT' : 'VIEW REVERSE';
      };

      const toggle = e => {
        if(!isTouch) return;
        if(isLink && !(e.target.closest && e.target.closest(CUE))) return;
        e.preventDefault();
        if(e.stopPropagation) e.stopPropagation();
        el.classList.toggle('flipped');
        setCue();
      };
      el.addEventListener('click', toggle);

      // Enter and Space flip the non-link visuals, which carry role="button".
      // On a tile, Enter belongs to the link: it must open the object.
      if(!isLink){
        el.addEventListener('keydown', e => {
          if(e.key === 'Enter' || e.key === ' '){
            e.preventDefault();
            el.classList.toggle('flipped');
            setCue();
          }
        });
        // Leaving with the keyboard resets to front
        el.addEventListener('blur', () => { el.classList.remove('flipped'); setCue(); });
      }
    });
  }
  bind();
  document.addEventListener('DOMContentLoaded', bind);
  window.__bindReverse = bind;
})();


/* ── CATALOGUE ─────────────────────────────────────────────────────────
   */


/* ── IMAGE DELIVERY ────────────────────────────────────────────────────
   Shopify originals are multi-megabyte. A 131-tile grid pulling full-size
   files stalls on slower connections and in browsers with tighter limits.
   Request a sized rendition instead, and always show why a tile is blank. */
function rhImg(u, w){
  if(!u) return '';
  if(u.indexOf('cdn.shopify.com') === -1) return u;
  return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
}
function rhImgTag(u, w, alt, cls){
  var src = rhImg(u, w);
  return '<img class="' + (cls||'') + '" src="' + src + '" alt="' + (alt||'').replace(/"/g,'&quot;') + '"'
       + ' loading="lazy" decoding="async" referrerpolicy="no-referrer"'
       + ' onload="this.parentNode &amp;&amp; this.parentNode.classList.remove(\'img-loading\')"'
       + ' onerror="rhImgFail(this)">';
}
function rhImgFail(img){
  var box = img.parentNode; if(!box) return;
  box.classList.remove('img-loading'); box.classList.add('img-failed');
  img.style.display = 'none';
  if(!box.querySelector('.img-note')){
    var n = document.createElement('div');
    n.className = 'img-note';
    n.textContent = 'IMAGE UNAVAILABLE';
    box.appendChild(n);
  }
}
/* Replay any image failures that happened before this deferred script ran. */
window.rhImgFail = rhImgFail;
if (window.__rhImgQueue) {
  window.__rhImgQueue.forEach(rhImgFail);
  window.__rhImgQueue.length = 0;
}

function rhMoney(v){ return (v===null||v===undefined||isNaN(v)) ? 'Price on inquiry'
                     : '$'+Number(v).toLocaleString('en-US',{maximumFractionDigits:0}); }



function rhSwap(btn,u){
  document.getElementById('prod-main-img').src = u;
  document.querySelectorAll('.pthumb').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const i = [...document.querySelectorAll('.pthumb')].indexOf(btn) + 1;
  const c = document.querySelector('.prod-count');
  if(c) c.textContent = i + ' / ' + document.querySelectorAll('.pthumb').length;
}

/* category counts on the categories page */

/* ══ v4.1 — CATEGORIES DROPDOWN, FILTERS, PROGRESSIVE LOADING ══════════════ */

// ── Categories is a parent, never a destination ───────────────────────────────
// Opens on hover where hovering is possible, and on click or Enter/Space
// everywhere, so it works by keyboard and on a touchscreen.
function rhDropdowns(){
  document.querySelectorAll('[data-dropdown]').forEach(function(wrap){
    if(wrap.dataset.init) return;
    wrap.dataset.init = '1';
    var btn = wrap.querySelector('[data-dropdown-trigger]');
    var panel = wrap.querySelector('[data-dropdown-panel]');
    if(!btn || !panel) return;
    var hoverable = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    var shutTimer = null;

    function open(){
      clearTimeout(shutTimer);
      panel.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
    function shut(){
      panel.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    function toggle(){ panel.hidden ? open() : shut(); }

    btn.addEventListener('click', function(e){
      e.preventDefault();
      // Where hovering already opened the panel, a click on the parent must not
      // close it again — that reads as the menu refusing to open. On a
      // touchscreen, where nothing hovers, the click is the only way in and so
      // it toggles.
      if(hoverable){ open(); } else { toggle(); }
    });
    btn.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'){ e.preventDefault(); toggle(); }
      if(e.key === 'ArrowDown'){ e.preventDefault(); open();
        var first = panel.querySelector('a'); if(first) first.focus(); }
    });
    if(hoverable){
      wrap.addEventListener('mouseenter', open);
      wrap.addEventListener('mouseleave', function(){ shutTimer = setTimeout(shut, 180); });
    }
    // Focus leaving the group closes it, which keeps tabbing predictable.
    wrap.addEventListener('focusout', function(e){
      if(!wrap.contains(e.relatedTarget)) shut();
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') shut(); });
    document.addEventListener('click', function(e){ if(!wrap.contains(e.target)) shut(); });
  });
}

// ── The same six links, expanding in place, inside the full-screen menu ──────
function rhAccordions(){
  document.querySelectorAll('[data-accordion]').forEach(function(wrap){
    if(wrap.dataset.init) return;
    wrap.dataset.init = '1';
    var btn = wrap.querySelector('[data-accordion-trigger]');
    var panel = wrap.querySelector('[data-accordion-panel]');
    if(!btn || !panel) return;
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var open = panel.hidden;
      panel.hidden = !open;
      wrap.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
}

// ── Filters apply as they are ticked; the form still submits without JS ──────
function rhFilters(){
  var form = document.getElementById('rh-filters');
  if(!form || form.dataset.init) return;
  form.dataset.init = '1';

  // The panels are absolutely positioned, so two open at once overlap and the
  // one on the left is hidden behind its neighbour. Opening one closes the
  // rest, the same way the Categories dropdown behaves.
  var groups = [].slice.call(form.querySelectorAll('details.rh-filter'));
  groups.forEach(function(d){
    d.addEventListener('toggle', function(){
      if(!d.open) return;
      groups.forEach(function(o){ if(o !== d) o.open = false; });
    });
  });
  document.addEventListener('click', function(e){
    if(form.contains(e.target)) return;
    groups.forEach(function(d){ d.open = false; });
  });
  form.addEventListener('keydown', function(e){
    if(e.key === 'Escape') groups.forEach(function(d){ d.open = false; });
  });
  // Every filter Shopify generates is named filter.*, so anything else in the
  // query string belongs to the storefront, not to this form: a sort order, a
  // search term, a campaign tag. Those are carried across. `page` is dropped
  // on purpose, because page 3 of the previous result set means nothing once
  // the filters change.
  function carryOver(target){
    new URLSearchParams(window.location.search).forEach(function(v, k){
      if(k.indexOf('filter.') === 0 || k === 'page') return;
      if(!target.has(k)) target.append(k, v);
    });
    return target;
  }

  function go(params){
    var out = carryOver(params).toString();
    // An empty query would otherwise leave a bare '?' in the address bar.
    window.location.href = window.location.pathname + (out ? '?' + out : '');
  }

  form.addEventListener('change', function(){
    var qs = new URLSearchParams();
    new FormData(form).forEach(function(v, k){
      // A blank price box is not a constraint; sending it would pin the range
      // to zero.
      if(v === '') return;
      qs.append(k, v);
    });
    go(qs);
  });

  // CLEAR drops the filters and nothing else. Its href is the bare collection
  // URL so it still works without JavaScript; with JavaScript it keeps the
  // sort order and anything else the storefront put in the query string.
  var clear = form.querySelector('.rh-filter-clear');
  if(clear){
    clear.addEventListener('click', function(e){
      e.preventDefault();
      go(new URLSearchParams());
    });
  }
}

// ── Progressive loading. The numbered links remain as the no-JS fallback ─────
function rhLoadMore(){
  var wrap = document.querySelector('[data-more]');
  var grid = document.querySelector('[data-grid]');
  if(!wrap || !grid || wrap.dataset.init) return;
  wrap.dataset.init = '1';
  var link = wrap.querySelector('[data-more-link]');
  var count = wrap.querySelector('[data-more-count]');
  if(!link) return;

  link.addEventListener('click', function(e){
    e.preventDefault();
    var url = link.getAttribute('href');
    if(!url || link.dataset.busy) return;
    link.dataset.busy = '1';
    var label = link.textContent;
    link.textContent = 'LOADING…';

    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function(r){
        if(!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-grid]');
        if(next){
          Array.prototype.forEach.call(next.children, function(node){
            grid.appendChild(node.cloneNode(true));
          });
        }
        var nextLink = doc.querySelector('[data-more-link]');
        if(nextLink){
          link.setAttribute('href', nextLink.getAttribute('href'));
          link.textContent = label;
        }else{
          link.remove();   // nothing left to load
        }
        var nextCount = doc.querySelector('[data-more-count]');
        if(count && nextCount){
          // The running total reads from the first item to the last one now on
          // the page, not just the page that was fetched.
          count.textContent = nextCount.textContent.replace(/Showing\s+\d+/, 'Showing 1');
        }
        if(typeof bindHover === 'function') bindHover();
        if(typeof initReveals === 'function') initReveals();
        // Tiles added by Load more need the front/reverse flip bound too.
        if(typeof window.__bindReverse === 'function') window.__bindReverse();
      })
      .catch(function(){
        // Fall back to a normal page load rather than leaving a dead button.
        window.location.href = url;
      })
      .finally(function(){ delete link.dataset.busy; });
  });
}

function rhV41(){ rhDropdowns(); rhAccordions(); rhFilters(); rhLoadMore(); }

/* ── PAGE BOOT ──────────────────────────────────────────────────────────────
   On the signed-off build these ran from the single-page router, which this
   theme does not have: Shopify serves a real document per URL. Without this
   the statement cue stayed ghosted, category blocks never reached their
   revealed state and the route cards never staggered in. Each initialiser
   already no-ops when its elements are absent, so one boot serves every
   template. */
function rhBoot(){
  rhV41();
  if(typeof initStatement  === 'function') initStatement();
  if(typeof initCategories === 'function') initCategories();
  if(typeof initReveals    === 'function') initReveals();
  if(typeof staggerIn      === 'function') staggerIn('.route', 70);
  if(typeof window.__bindReverse === 'function') window.__bindReverse();
  if(typeof window.__syncHeader === 'function') window.__syncHeader();
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', rhBoot);
}else{
  rhBoot();
}
/* Re-run after a section is re-rendered in the theme editor. */
document.addEventListener('shopify:section:load', rhBoot);
/* Category links: scroll directly and skip the opening logo */
(function () {
  const hashes = ['#cat-tcgs', '#cat-trading-cards'];

  function showCategory(hash) {
    const section = document.getElementById(hash.slice(1));
    if (!section) return false;

    if (typeof exitHero === 'function') exitHero();
    if (typeof closeMenu === 'function') closeMenu();

    const intro = document.getElementById('hero');
    if (intro) intro.style.display = 'none';

    requestAnimationFrame(() => {
      section.scrollIntoView({ behavior: 'auto', block: 'start' });
    });
    return true;
  }

  if (hashes.includes(location.hash)) {
    showCategory(location.hash);
    window.addEventListener('load', () => showCategory(location.hash), {
      once: true
    });
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a');
    if (!link || event.button !== 0 || event.ctrlKey ||
        event.metaKey || event.shiftKey || event.altKey) return;

    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin ||
        url.pathname !== location.pathname ||
        !hashes.includes(url.hash)) return;

    if (showCategory(url.hash)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      history.replaceState(null, '', url.hash);
    }
  }, true);
})();